var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(this.message))]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("Log In")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }